
import { addStayCancelPolicy, getStayCancelPolicy, updateStayCancelPolicy } from '@/api/stayCancelPolicy';
import { ElForm } from 'element-ui/types/form';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
})
export default class extends Vue {
  @Prop({ default: null }) private idx!: any;

  mounted() {
    this.init();
  }

  private loading = true;

  private formData: any = {
    termDay: null,
    termTime: '',
    percentage: null,
    description: '',
  }

  private rules = {
    termDay: [
      { required: true, message: '규정일을 입력하세요.', trigger: 'blur' },
    ],
    termTime: [
      { required: true, message: '규정시간을 입력하세요.', trigger: 'blur' },
      { validator: this.validateTermTime, trigger: 'change' },
    ],
    percentage: [
      { required: true, message: '수수료 퍼센트를 입력하세요.', trigger: 'blur' },
    ],
  }

  private validateTermTime(rule: any, value: string, callback: Function) {
    if (value === '00:00') {
      callback(new Error('00:00은 설정할 수 없습니다. (예: 23:59)'));
    } else {
      callback();
    }
  }

  private init() {
    if (this.idx) {
      getStayCancelPolicy(this.idx).then((res) => {
        this.formData = res.data;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  private handleClickSave() {
    (this.$refs.formRef as ElForm).validate((valid: boolean) => {
      if (valid) {
        if (this.idx) {
          updateStayCancelPolicy(this.idx, this.formData).then(() => {
            this.$message.success('환불 규정이 수정되었습니다.');
            this.$emit('save');
          });
        } else {
          addStayCancelPolicy(this.formData).then(() => {
            this.$message.success('환불 규정이 추가되었습니다.');
            this.$emit('save');
          });
        }
      }
    });
  }

  private handleClickCancel() {
    this.$emit('close');
  }
}
